export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('quickBook', {
            url: '/quickbook',
            component: 'quickBook'
        })
        ;
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/page.routes.js